import { EnderecoField } from '@/components/pedido/fields/EnderecoField';
import type { ObrigatoriedadeConfig } from '@/hooks/useObrigatoriedadesItem';

interface EnderecoData {
  cep?: string;
  logradouro?: string;
  numero?: string;
  complemento?: string;
  bairro?: string;
  cidade?: string;
  uf?: string;
}

interface Props {
  endereco: EnderecoData | null;
  onChange: (endereco: EnderecoData) => void;
  onBlur?: () => void;
  obrigatorio?: boolean;
  config?: ObrigatoriedadeConfig;
}

export function EnderecoInstalacaoInline({ 
  endereco, 
  onChange,
  onBlur,
  obrigatorio = false,
  config 
}: Props) {
  const defaultConfig: ObrigatoriedadeConfig = config || {
    id: 'endereco-instalacao-default',
    mensagem_erro: 'Endereço de instalação completo é obrigatório',
    mensagem_ajuda: 'Endereço onde o serviço será instalado',
    validacao_regex: null,
    valor_default: null,
    minimo: null,
    maximo: null,
    permite_multiplos: false,
    obrigatorio_em_negociacao: false,
    obrigatorio_em_pedido_fechado: true,
    obrigatorio_em_rascunho: false,
    obrigatoriedades_catalogo: {
      id: 'endereco-instalacao',
      codigo: 'ENDERECO_INSTALACAO',
      nome: 'Endereço de Instalação',
      tipo_dado: 'endereco',
      campo_tabela: 'endereco_instalacao'
    }
  };

  return (
    <EnderecoField
      config={defaultConfig}
      endereco={endereco || {}}
      onChange={onChange}
      onBlur={onBlur}
      obrigatorio={obrigatorio}
    />
  );
}
